define(['rest/request/batchRequestServiceFactory', 'rest/request/singleRequestServiceFactory'],
    function(batchRequestServiceFactory, singleRequestServiceFactory) {
        return {
            single: singleRequestServiceFactory,
            batch: batchRequestServiceFactory
        };
    });



// WEBPACK FOOTER //
// ./rest/request/requestFactory.js